export * from '../src/composites/wui-link/index.js';
//# sourceMappingURL=wui-link.js.map